import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';

import AngikarNama from './angikar-nama';
import CashMemo from './cash-memo';
import Certificate from './certificate';
import Detail from './detail';
import Form from './form';
import Invoice from './invoice';
import List from './list';
import NotFound from '../not-found';
import Receive from './receive';
import RegistrationApplication from './registration-application';
import Transaction from './transaction';

export default class Sale extends PureComponent {
  render() {
    return (
      <Switch>
        <Route component={List} exact path={this.props.match?.path} />
        <Route
          component={Form}
          exact
          path={`${this.props.match?.path}/create`}
        />
        <Route
          component={AngikarNama}
          exact
          path={`${this.props.match?.path}/:id/angikar-nama`}
        />
        <Route
          component={CashMemo}
          exact
          path={`${this.props.match?.path}/:id/cash-memo`}
        />
        <Route
          component={Certificate}
          exact
          path={`${this.props.match?.path}/:id/certificate`}
        />
        <Route
          component={Detail}
          exact
          path={`${this.props.match?.path}/:id/detail`}
        />
        <Route
          component={Form}
          exact
          path={`${this.props.match?.path}/:id/edit`}
        />
        <Route
          component={Invoice}
          exact
          path={`${this.props.match?.path}/:id/invoice`}
        />
        <Route
          component={Receive}
          exact
          path={`${this.props.match?.path}/:id/receive`}
        />
        <Route
          component={RegistrationApplication}
          exact
          path={`${this.props.match?.path}/:id/registration-application`}
        />
        <Route
          component={Transaction}
          exact
          path={`${this.props.match?.path}/:id/transaction`}
        />
        <Route component={NotFound} />
      </Switch>
    );
  }
}
